import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-reporting';
import { useLazyComponent } from '@trello/use-lazy-component';

interface InlineInspirationsPopoverProps {
  boardId: string;
  orgId: string;
  onClose: () => void;
  returnBoardShortLink: string;
}

export const LazyInlineInspirationsPopover: FunctionComponent<InlineInspirationsPopoverProps> = ({
  boardId,
  orgId,
  onClose,
  returnBoardShortLink,
}) => {
  const InlineInspirationsPopover = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "inline-inspirations-popover" */ './InlineInspirationsPopover'
      ),
    { namedImport: 'InlineInspirationsPopover' },
  );

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <InlineInspirationsPopover
          boardId={boardId}
          orgId={orgId}
          onClose={onClose}
          returnBoardShortLink={returnBoardShortLink}
        />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
